export default __webpack_public_path__ + "static/go-hero-banner-e2cc6e53856dbbe9cea27458132b0ccf.webp";